import { render } from "./CreateFrs.vue?vue&type=template&id=2e18fec9"
import script from "./CreateFrs.vue?vue&type=script&lang=js"
export * from "./CreateFrs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__